import ComponentRegistry from './../model/ComponentRegistry.js';
import NoComponent from './../components/common/NoComponent';

const ComponentHelper = function(userStore){
	
	let prefix = null;

	if(userStore && userStore.getSchoolPrefix){
		prefix = (userStore.getSchoolPrefix() && userStore.getSchoolPrefix().length > 0) ? userStore.getSchoolPrefix() : "";
	}else{
		prefix = "";
	}

	return{
		getCmp:function(cmpName){
			if(cmpName){
				if(prefix && ComponentRegistry.exists(prefix + cmpName.toLowerCase())){
					console.log("Component found with the prefix :  ", prefix + cmpName.toLowerCase());

					return ComponentRegistry.get(prefix + cmpName.toLowerCase());
				}else if(ComponentRegistry.exists(cmpName)){
					console.log("Default Component found : ", cmpName);

					return ComponentRegistry.get(cmpName);
				}
			}

			console.warn("The component does not exist or may not have been registered: ", cmpName);    

			return NoComponent;
		},
		getCmpByName:function(cmpName, altCmpName=null){

			/**
			* IMPORTANT: The following is purely based on assumption that
			* _ is used just for prefix and not while registering any component.
			*/
			if(!altCmpName && cmpName){
				try{
					altCmpName = (cmpName.includes("_")) ? cmpName.split("_")[1] : cmpName;
				}catch(e){
					altCmpName = cmpName;
					console.error(e);
				}
			}
			
			if(cmpName && ComponentRegistry.exists(cmpName.toLowerCase())){
				console.log("Component found :  ", cmpName.toLowerCase());

				return ComponentRegistry.get(cmpName.toLowerCase());
			}else if(altCmpName && ComponentRegistry.exists(altCmpName.toLowerCase())){
				console.log("Default Component found : ", altCmpName);

				return ComponentRegistry.get(altCmpName);
			}
	

			console.warn("The component does not exist or may not have been registered: ", cmpName);    

			return NoComponent;
		}
		}
	};


	export default ComponentHelper;


// WEBPACK FOOTER //
// ./src/util/ComponentHelper.js